import { defineAction } from '~/prix'
import { z } from 'zod'
import trainingDeleteAction from './trainingDelete.action.json' with { type: 'json' }
import { trainingObject } from '../trainingObject'
import { dateOrIsoString } from '~/prix/types/date'

const trainingDeleteDefinition = defineAction({
  ...trainingDeleteAction,

  input: z.object({ id: trainingObject.shape.id, updatedAt: dateOrIsoString().nullish() }),
  output: z.object({}),
})

export default trainingDeleteDefinition
